import React from "react";
import { Modal } from "react-bootstrap";
import { IoClose } from "react-icons/io5";
import { FiLock } from "react-icons/fi";
import "../../styles/NoPermissionModal.css";

const NoPermissionModal = ({
  show,
  onClose,
  title = "Access Restricted",
  message = "You do not have permission to perform this action. Please contact your system administrator if you require access.",
  tripId = "",
  stageName = "",
  actionName = "",
  permissionName = "",
  details = null,
}) => {
  const hasDetails = Boolean(
    tripId ||
      stageName ||
      actionName ||
      permissionName ||
      (Array.isArray(details) && details.length > 0)
  );

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={true}
      dialogClassName="no_permission_modal"
    >
      <Modal.Body className="no_permission_modal_body">
        <button
          type="button"
          className="no_permission_close_btn"
          onClick={onClose}
          aria-label="Close"
        >
          <IoClose />
        </button>

        <div className="no_permission_icon_container">
          <div className="no_permission_icon_ring">
            <div className="no_permission_icon_wrap" aria-hidden="true">
              <FiLock />
            </div>
          </div>
        </div>

        <h3 className="no_permission_title">{title}</h3>
        <p className="no_permission_message">{message}</p>

        {hasDetails && (
          <div className="no_permission_details_card">
            {tripId && (
              <div className="no_permission_detail_item">
                <span className="no_permission_detail_label">Ref / ID</span>
                <span className="no_permission_trip_tag">{tripId}</span>
              </div>
            )}
            {stageName && (
              <div className="no_permission_detail_item">
                <span className="no_permission_detail_label">Target Stage</span>
                <span className="no_permission_stage_tag">{stageName}</span>
              </div>
            )}
            {actionName && (
              <div className="no_permission_detail_item">
                <span className="no_permission_detail_label">Action</span>
                <span className="no_permission_stage_tag">{actionName}</span>
              </div>
            )}
            {permissionName && (
              <div className="no_permission_detail_item">
                <span className="no_permission_detail_label">Required Permission</span>
                <span className="no_permission_perm_tag">{permissionName}</span>
              </div>
            )}
            {Array.isArray(details) &&
              details.map((item, idx) => (
                <div key={idx} className="no_permission_detail_item">
                  <span className="no_permission_detail_label">{item.label}</span>
                  <span className="no_permission_stage_tag">{item.value}</span>
                </div>
              ))}
          </div>
        )}
      </Modal.Body>

      <Modal.Footer className="no_permission_modal_footer">
        <button
          type="button"
          className="no_permission_confirm_btn"
          onClick={onClose}
        >
          Understood
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default NoPermissionModal;
